import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslocoService } from '@jsverse/transloco';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { User } from '../../models/user';


@Pipe({
    name: 'since',
    standalone: false
})
export class DateSincePipe implements PipeTransform {

  constructor(private translocoService: TranslocoService) {
  }

  transform(timestamp: string | number | undefined, _now?: number): string | null {
    if (timestamp === undefined) {
      return null;
    }
    const now = new Date();
    const date = new Date(timestamp);

    let diff = (now.getTime() - date.getTime()) / 1000;
    diff = Math.abs(Math.floor(diff));

    const days = Math.floor(diff / (24 * 60 * 60));
    let leftSec = diff - days * 24 * 60 * 60;

    const hrs = Math.floor(leftSec / (60 * 60));
    leftSec = leftSec - hrs * 60 * 60;

    const min = Math.floor(leftSec / (60));

    const datePipe = new DatePipe(this.translocoService.getActiveLang());

    if (now.getFullYear() === date.getFullYear()) {
      if (days === 0) {
        if (hrs === 0) {
            if (min === 0) {
                return this.translocoService.translate('now');
            }
            else {
              return min + ' min';
            }
        }
        else {
          return (now.getDay() !== date.getDay()) ? 'hier' : datePipe.transform(date, 'HH') +'h' +datePipe.transform(date, 'mm');
        }
      }
      else {
        return (days <= 7) ? datePipe.transform(date, 'EEE') : datePipe.transform(date, 'dd MMM');
      }
    }
    else {
      return datePipe.transform(date, 'dd MMM y');
    }
  }
}

@Pipe({
    name: 'format',
    standalone: false
})
export class DateFormatPipe implements PipeTransform {
  transform(timestamp: string | number | undefined): string | null {
    if (timestamp === undefined) {
      return null;
    }
    const now = new Date();
    const date = new Date(timestamp);

    let diff = (now.getTime() - date.getTime()) / 1000;
    diff = Math.abs(Math.floor(diff));

    const days = Math.floor(diff / (24 * 60 * 60));
    let leftSec = diff - days * 24 * 60 * 60;

    const hrs = Math.floor(leftSec / (60 * 60));
    leftSec = leftSec - hrs * 60 * 60;

    const min = Math.floor(leftSec / (60));

    const sec = leftSec - (min * 60);
    if (hrs === 0) {
      if (min === 0) {
        return sec + ' sec';
      }else {
        return min + ' min ' + sec  + ' sec';
      }
    }
    else {
      return  hrs + ' hour ' + min + ' min ';
    }
  }
}


@Pipe({
    name: 'duration',
    standalone: false
})
export class DurationPipe implements PipeTransform {
  transform(diff: number | undefined): string | null {
    if (diff === undefined) {
      return null;
    }

    diff = Math.abs(Math.floor(diff));

    const days = Math.floor(diff / (24 * 60 * 60));
    let leftSec = diff - days * 24 * 60 * 60;

    const hrs = Math.floor(leftSec / (60 * 60));
    leftSec = leftSec - hrs * 60 * 60;

    const min = Math.floor(leftSec / (60));

    const sec = leftSec - (min * 60);
    if (hrs === 0) {
      if (min === 0) {
        return sec + ' sec';
      }else {
        return min + ' min ' + sec  + ' sec';
      }
    }
    else {
      if (days > 0) {
        return  days + ' day ' + hrs + ' hour ';
      }
      return  hrs + ' hour ' + min + ' min ';
    }
  }
}

@Pipe({
    name: 'itemName',
    standalone: false
})
export class ItemNamePipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {
  }

  transform(label: string, id: string): string {
    return this.translocoService.translate(label) + ' ' + id.slice(0,4).toUpperCase();
  }
}


@Pipe({
    name: 'wgs84',
    standalone: false
})
export class ECEFToWGS84Pipe implements PipeTransform {

  transform(ecef: Array<number>): string {
    const cartographic = Cesium.Cartographic.fromCartesian(Cesium.Cartesian3.fromArray(ecef));
    const longitude = Cesium.Math.toDegrees(cartographic.longitude);
    const latitude = Cesium.Math.toDegrees(cartographic.latitude);
    return longitude.toFixed(10) + ", " + latitude.toFixed(10);
  }
}


@Pipe({
    name: 'linkify',
    standalone: false
})
export class LinkifyPipe {
  constructor(private sanitizer: DomSanitizer) {}

  transform(text: string): SafeHtml {
    if (!text) return '';

    const urlRegex = /(https?:\/\/[^\s]+)/g;

    const html = text.replace(urlRegex, (url) => {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}

@Pipe({
    name: 'sentencecase',
    standalone: false
})
export class SentenceCasePipe implements PipeTransform {

  transform(sentence: string): string {
    return (sentence) ? sentence[0].toUpperCase() + sentence.slice(1) : '';
  }
}

@Pipe({
    name: 'mentionify',
    standalone: false
})
export class MentionifyPipe implements PipeTransform {
  transform(
    value: string | null | undefined,
    users: User[]
  ): string {
    if (!value) {
      return '';
    }

    return value.replace(
      /(^|\s)@([a-zA-Z0-9_.-]+)/g,
      (match, prefix, username) => {
        const user = users?.find(u => u.username === username);

        const display = user ? user.name : username;

        return `${prefix}<span class="mention">@${display}</span>`;
      }
    );
  }
}

